"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerHandle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const Button_1 = require("../Button");
const Drawer_1 = require("../Drawer");
const useScrollHeight_1 = require("../../hooks/useScrollHeight");
const Box_1 = require("../Box");
const tools_1 = require("../../tools");
const DrawerHandle = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { expanded, setExpanded, setHandleScrollHeight, breakpointInPixels } = react_1.useContext(Drawer_1.DrawerContext);
    const divRef = react_1.useRef(null);
    const scrollHeight = useScrollHeight_1.useScrollHeight(divRef);
    react_1.useEffect(() => {
        setHandleScrollHeight(scrollHeight);
    }, [scrollHeight, setHandleScrollHeight]);
    return (jsx_runtime_1.jsxs(Box_1.Box, Object.assign({ display: "flex", flexDirection: "row" }, props, { ref: divRef, onClick: () => setExpanded(!expanded) }, { children: [jsx_runtime_1.jsx(StyledButton, Object.assign({ padding: "0.5rem 0.5rem 0.5rem 1rem", background: "transparent", color: "inherit", boxShadow: "none", breakpointInPixels: breakpointInPixels, onClick: () => setExpanded(!expanded) }, { children: jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { rotation: expanded ? undefined : 180, icon: free_solid_svg_icons_1.faChevronDown }, void 0) }), void 0),
            jsx_runtime_1.jsx(Box_1.Box, Object.assign({ flex: 1 }, { children: children }), void 0)] }), void 0));
};
exports.DrawerHandle = DrawerHandle;
const StyledButton = tools_1.styled(Button_1.Button) `
  outline: none !important;
  @media screen and (min-width: ${({ breakpointInPixels }) => breakpointInPixels}px) {
    display: none;
  }
`;
//# sourceMappingURL=index.js.map